<script setup lang="ts">
import { Workshop } from '@/@types/workshop'
import BackdropBg from '@/components/shared/main/BackdropBg.vue'
import Hero from '@/components/shared/main/Hero.vue'
import Workshops from '@/components/shared/main/Workshops.vue'
import DarkLayout from '@/layouts/DarkLayout.vue'
import { Head } from '@inertiajs/vue3'

defineProps<{
    workshops: Workshop[]
}>()
</script>

<template>
    <Head title="Home"></Head>

    <DarkLayout>
        <main class="overflow-hidden bg-[#444] md:min-h-dvh">
            <div class="relative">
                <BackdropBg />

                <div class="relative pb-12 lg:pb-24">
                    <Hero />
              
                    <Workshops :workshops="workshops" />
                </div>
            </div>
        </main>
    </DarkLayout>
</template>
